var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentChartBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-outline/document-chart-bar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.3335 18.9995V15.4995C26.3335 13.0142 24.3188 10.9995 21.8335 10.9995H19.8335C19.0051 10.9995 18.3335 10.3279 18.3335 9.49951V7.49951C18.3335 5.01423 16.3188 2.99951 13.8335 2.99951H11.3335M12.3335 21.9995V22.9995M16.3335 18.9995V22.9995M20.3335 15.9995V22.9995M14.3335 2.99951H7.8335C7.00507 2.99951 6.3335 3.67108 6.3335 4.49951V27.4995C6.3335 28.3279 7.00507 28.9995 7.8335 28.9995H24.8335C25.6619 28.9995 26.3335 28.3279 26.3335 27.4995V14.9995C26.3335 8.3721 20.9609 2.99951 14.3335 2.99951Z",
    stroke: "#22D3EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentChartBar);
export default __webpack_public_path__ + "static/media/document-chart-bar.af541e5ea6d79c59659023e5bc3c58e1.svg";
export { ForwardRef as ReactComponent };